export default "/tag/@tag";
